class SearchForm extends HTMLElement {
  constructor() {
    super();
    let self = this;
    this.toggleBtn = document.querySelector('[data-search-toggle]');
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    window.klevuElements = [];
    this.resizeTimeout;
    this.lastWidth = window.innerWidth;

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      this.input.addEventListener(
        'focus',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    document.querySelector(".header__top").addEventListener("click", (event) => {
      let target = event.target;

      if (
        target.classList.contains('header__icon--search') || 
        target.closest('.header__icon--search') && 
        !document.body.classList.contains('show-header-search') && 
        !this.input.closest('#menu-drawer')
      ) {
          document.body.classList.add('show-header-search');
          this.input.focus();
      }
    });

    window.addEventListener('resize', this.onResize.bind(this));
  }

  onChange() {
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    this.searchInNav();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
    }
  }

  searchInNav() {
    if (!document.body.classList.contains('menu-opening')) return;

    let attempts = 0;
    const maxAttempts = 200;

    const intervalId = setInterval(() => {
      const el = document.querySelector('#Details-menu-drawer-container');
      attempts++;

      if (!el) {
        return;
      }

      if (!el.hasAttribute('open')) {
        el.setAttribute('open', 'true');
        clearInterval(intervalId);
        el.querySelector('.predictive-search').focus();

        return;
      }

      if (attempts >= maxAttempts) {
        clearInterval(intervalId);
      }
    }, 5);
  }
}

customElements.define('search-form', SearchForm);
